export default __webpack_public_path__ + "5da212bf292622733ea62e9be0d810de.png";